export const renderErrorMessage = (message: string) => {
  const noticeWrap = document.createElement("div")
  noticeWrap.classList.add("validator")

  const notice = document.createElement("span")
  notice.innerHTML = message
  notice.classList.add("erorr-s")

  noticeWrap.appendChild(notice)

  return noticeWrap
}
